import { Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import React from "react";
import API from "@/api/serverCall";
import { profileInfoType } from "types/user";
import { useTranslation } from "react-i18next";

const initProfileInfo = {
	companyId: 0,
	companyName: "",
	id: 0,
	nameFirst: "",
	nameLast: "",
	email: "",
	createdAt: "",
	isOwner: true,
};

const AccountProfile: React.FC = () => {
	const { t } = useTranslation();
	const [profileInfo, setProfileInfo] =
		React.useState<profileInfoType>(initProfileInfo);

	const getAccountProfileInfo = () => {
		// loading
		try {
			API.GET<profileInfoType>({
				link: `/user`,
			}).then((response) => {
				setProfileInfo(response.data);
			});
		} catch (error) {
			console.error(error);
		}
	};
	React.useEffect(() => {
		getAccountProfileInfo();
	}, []);
	return (
		<div style={{ margin: "3rem 2rem", flexGrow: 1 }}>
			<Typography
				sx={{ color: "#545351", fontSize: "1.2rem", marginBottom: "1rem" }}
			>
				{t("account_profile.title")}
			</Typography>
			<div
				className="Account__Upper__Container"
				style={{
					border: "2px solid #E0E0E0",
					backgroundColor: "#FFFFFF",
					marginBottom: "2rem",
				}}
			>
				<div
					className="AccountName"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "2rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "60%",
							display: "inline-block",
						}}
					>
						{t("account_profile.name")}
					</span>
					<div style={{ width: "20%", marginRight: "1rem" }}>
						<span style={{ padding: "4px" }}>
							{t("account_profile.first_name")}
						</span>
						<TextField
							id="outlined-basic"
							variant="outlined"
							size="small"
							disabled={true}
							value={profileInfo.nameFirst}
							fullWidth={true}
						/>
					</div>
					<div style={{ width: "20%" }}>
						<span style={{ padding: "4px" }}>
							{t("account_profile.last_name")}
						</span>
						<TextField
							id="outlined-basic"
							variant="outlined"
							size="small"
							value={profileInfo.nameLast}
							disabled={true}
							fullWidth={true}
						/>
					</div>
				</div>
			</div>
			<div
				className="MainSection__Under__Container"
				style={{ border: "2px solid #E0E0E0", backgroundColor: "#FFFFFF" }}
			>
				<div
					className="Email"
					style={{ display: "flex", alignItems: "center", padding: "2rem" }}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "70%",
							display: "inline-block",
						}}
					>
						{t("account_profile.email")}
					</span>
					<span>{profileInfo.email}</span>
				</div>
				<div style={{ border: "1px solid #E0E0E0" }} />
				<div
					className="Organization"
					style={{ display: "flex", alignItems: "center", padding: "2rem" }}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "70%",
							display: "inline-block",
						}}
					>
						{t("account_profile.organization")}
					</span>
					<span>{profileInfo.companyName}</span>
				</div>
				<div style={{ border: "1px solid #E0E0E0" }} />
				<div
					className="Role"
					style={{ display: "flex", alignItems: "center", padding: "2rem" }}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "70%",
							display: "inline-block",
						}}
					>
						{t("account_profile.role")}
					</span>
					<span>{profileInfo.isOwner ? "Owner" : "Member"}</span>
				</div>
			</div>
		</div>
	);
};

export default AccountProfile;
